import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/community/free-board/new/page.tsx");
